module.exports = __webpack_public_path__ + "img/vegetable-morels-350x184.9b27b184.jpg";